
interface LayerModalExitOptionsProps {
  okAction: () => void;
  okString?: string;
  cancelAction: () => void;
  cancelString?: string;
}

const LayerModalExitOptions = ({ okAction, okString = "OK", cancelAction, cancelString = "Cancel" }: LayerModalExitOptionsProps) => {
  return (
    <footer>
      <button
        onClick={okAction}>
        {okString}
      </button>
      <button
        onClick={cancelAction}>
        {cancelString}
      </button>
    </footer>
  )
}
export default LayerModalExitOptions;